// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { Box, Grid } from '../base';

interface Props {
  children?: React.ReactNode;
}
export default function CenteredView({ children }: Props) {
  return (
    <Grid sx={{ margin: 0, width: '100%', p: { xs: 1, sm: 2 } }} container spacing={0} justifyContent="center">
      <Grid sx={{ display: 'flex', justifyContent: 'center' }} xs={12} sm={12} md={10}>
        <Box
          component="div"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            maxWidth: 1200,
            width: '100%',
          }}
        >
          {children}
        </Box>
      </Grid>
    </Grid>
  );
}
